const React = require('react');
const {
  UserContextProvider,
} = require('./src/utils/hooks/useUserContext/context');

import { QueryClientProvider } from 'react-query';

import { queryClient } from './src/utils/api/instances';
require('./src/fonts/ew-font.css');

const wrapRootElement = ({ element }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <UserContextProvider>{element}</UserContextProvider>
    </QueryClientProvider>
  );
};

const onClientEntry = () => {
  // IntersectionObserver polyfill
  if (typeof window.IntersectionObserver === `undefined`) {
    import(`intersection-observer`)
  }
}

export { wrapRootElement, onClientEntry };
